import script from "./StatusTimeline.vue?vue&type=script&setup=true&lang=js"
export * from "./StatusTimeline.vue?vue&type=script&setup=true&lang=js"

import "./StatusTimeline.vue?vue&type=style&index=0&id=81411632&scoped=true&lang=scss"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81411632"]])

export default __exports__